if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.scrollLock = null;
      }

      hide() {
        super.hide();
        document.documentElement.classList.remove('product-media-modal-open');

        if (!this.scrollLock) return;

        const { scrollY, bodyStyles } = this.scrollLock;
        Object.assign(document.body.style, bodyStyles);
        this.scrollLock = null;
        window.scrollTo(0, scrollY);
      }

      show(opener) {
        const body = document.body;
        this.scrollLock = {
          scrollY: window.scrollY || window.pageYOffset || 0,
          bodyStyles: {
            position: body.style.position,
            top: body.style.top,
            left: body.style.left,
            right: body.style.right,
            width: body.style.width,
          },
        };

        super.show(opener);
        document.documentElement.classList.add('product-media-modal-open');
        body.style.position = 'fixed';
        body.style.top = `-${this.scrollLock.scrollY}px`;
        body.style.left = '0';
        body.style.right = '0';
        body.style.width = '100%';
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        if (!activeMedia) return;

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        const container = this.querySelector('[role="document"]');
        if (container) {
          const mediaBounds = activeMedia.getBoundingClientRect();
          const containerBounds = container.getBoundingClientRect();
          const mediaWidth = mediaBounds.width || activeMedia.width || 0;

          container.scrollTo({
            top: container.scrollTop + mediaBounds.top - containerBounds.top,
            left: Math.max(0, (mediaWidth - container.clientWidth) / 2),
          });
        }

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
